import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Layers, LogOut, Settings } from 'lucide-react';

function Header({ username, onLogout }) {
  const navigate = useNavigate();
  const [showConfigMenu, setShowConfigMenu] = useState(false);

  const handleLogout = async () => {
    try {
      await axios.post('/api/logout', {}, { withCredentials: true });
      setShowConfigMenu(false);
      onLogout(); // Reset login state in parent
      navigate('/login'); // Redirect
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-white shadow-md z-50 flex items-center justify-between px-4 py-2">
      <ul className="flex">
        <li className="mr-6">
          <Link to={`/`} className="hover:underline font-medium">
            The Coloring Corner
          </Link>
        </li>
        <li className="mr-6">
          <Link to="/books" className="mr-6 hover:underline font-medium">
            My Books
          </Link>
        </li>
      </ul>
      <div className="relative flex items-center gap-3">
        {username && (
          <span className="hidden text-sm text-gray-600 sm:inline">
            Logged in as <strong>{username}</strong>
          </span>
        )}
        <button
          type="button"
          onClick={() => setShowConfigMenu((open) => !open)}
          className="flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-700 hover:bg-gray-100"
          title="Configuration"
          aria-label="Open configuration menu"
        >
          <Settings size={18} />
        </button>
        {showConfigMenu && (
          <div className="absolute right-0 top-full mt-2 w-48 rounded-xl border border-gray-200 bg-white py-2 shadow-lg">
            <Link
              to="/variants"
              onClick={() => setShowConfigMenu(false)}
              className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <Layers size={16} />
              Variants
            </Link>
            <Link
              to="/layout-templates"
              onClick={() => setShowConfigMenu(false)}
              className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <Settings size={16} />
              Layout templates
            </Link>
            <button
              type="button"
              onClick={handleLogout}
              className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50"
            >
              <LogOut size={16} />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

Header.propTypes = {
  username: PropTypes.string.isRequired,
  onLogout: PropTypes.func.isRequired,
};

export default Header;
